import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc0008',
    ecrans: ['00-2']
});
